import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { ValidacionResultadosAprendizajeDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class ValidacionResultadosAprendizajeService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private readonly http: HttpClient) {}

  getValidacionResultadosAprendizajeService(): Observable<
    BodyListResponse<ValidacionResultadosAprendizajeDTO>
  > {
    return this.http.get<BodyListResponse<ValidacionResultadosAprendizajeDTO>>(
      API_URL + '/api/v1/validacionResultadosAprendizaje/todos',
    );
  }

  guardarValidacionResultadosAprendizajeService(
    validacionResultadosAprendizajeDTO: ValidacionResultadosAprendizajeDTO,
  ): Observable<BodyResponse<ValidacionResultadosAprendizajeDTO>> {
    return this.http.post<BodyResponse<ValidacionResultadosAprendizajeDTO>>(
      API_URL + '/api/v1/validacionResultadosAprendizaje',
      validacionResultadosAprendizajeDTO,
    );
  }

  getValidacionResultadosAprendizajePorCodigoService(
    codigo: string,
  ): Observable<BodyResponse<ValidacionResultadosAprendizajeDTO>> {
    return this.http.get<BodyResponse<ValidacionResultadosAprendizajeDTO>>(
      API_URL + '/api/v1/validacionResultadosAprendizaje/' + codigo,
    );
  }
}
